import { render, staticRenderFns } from "./AndroidIcon.vue?vue&type=template&id=5431124d&scoped=true"
import script from "./AndroidIcon.vue?vue&type=script&lang=js"
export * from "./AndroidIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5431124d",
  null
  
)

export default component.exports